var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"download-btn",attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.$emit('download-item')}}},[_c('img',{staticClass:"download-btn-img",attrs:{"src":_vm.urlImage,"alt":_vm.alt}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d1630ab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/diagnosis/download-btn.vue
// module id = 1517
// module chunks = 10 45 50 53 54 55 64 68